import React from 'react';
import { STAGES } from '../data/mockData';
import { LoanStage } from '../types';
interface StageFilterProps {
  activeStage: LoanStage | 'All';
  onStageChange: (stage: LoanStage | 'All') => void;
  stageCounts: Record<LoanStage | 'All', number>;
}
export const StageFilter: React.FC<StageFilterProps> = ({
  activeStage,
  onStageChange,
  stageCounts
}) => {
  return <div className="w-full overflow-x-auto pb-4 hide-scrollbar" data-id="element-110">
      <div className="flex space-x-2 min-w-max" data-id="element-111">
        <button onClick={() => onStageChange('All')} className={`flex items-center px-4 py-2 rounded-full text-sm font-medium transition-all ${activeStage === 'All' ? 'bg-gray-900 text-white shadow-sm' : 'bg-white text-gray-600 border border-gray-200 hover:border-gray-300 hover:bg-gray-50'}`} data-id="element-112">
          All Leads
          <span className={`ml-2 px-2 py-0.5 rounded-full text-xs font-semibold flex items-center justify-center ${activeStage === 'All' ? 'bg-gray-700 text-gray-100' : 'bg-gray-100 text-gray-600'}`} data-id="element-113">
            {stageCounts['All']}
          </span>
        </button>

        {STAGES.map(stage => <button key={stage} onClick={() => onStageChange(stage)} className={`flex items-center px-4 py-2 rounded-full text-sm font-medium transition-all ${activeStage === stage ? 'bg-gray-900 text-white shadow-sm' : 'bg-white text-gray-600 border border-gray-200 hover:border-gray-300 hover:bg-gray-50'}`} data-id="element-114">
            {stage}
            <span className={`ml-2 px-2 py-0.5 rounded-full text-xs font-semibold flex items-center justify-center ${activeStage === stage ? 'bg-gray-700 text-gray-100' : 'bg-gray-100 text-gray-600'}`} data-id="element-115">
              {stageCounts[stage] || 0}
            </span>
          </button>)}
      </div>
    </div>;
};